import { useQuery } from "@tanstack/react-query";
import {
  sowingBreakdownReportApi,
  type SowingBreakdownFilters,
} from "../services/sowingBreakdownReportApi";

export const useSowingBreakdownReport = (
  filters: SowingBreakdownFilters,
  pageNumber: number,
  pageSize: number,
  runToken: number
) =>
  useQuery({
    queryKey: [
      "reports",
      "sowing-breakdown",
      filters,
      pageNumber,
      pageSize,
      runToken,
    ],
    queryFn: () =>
      sowingBreakdownReportApi.getSowingBreakdownReport(filters, pageNumber, pageSize),
    enabled: runToken > 0,
    placeholderData: (prev) => prev,
  });
